<template>
	<div class="Target">
		<!-- <el-row>
			<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
				<p class="my-4 pt-4 ml-6 font-bold">
					Set Items Per Labour Hour(IPLH) Target:
				</p>
			</el-col>
		</el-row> -->
		<div class="py-2" style="width: 7rem;">
				<BaseButton buttonclass="btn p-2 text-xs" @click="openTargetPopup">
					Add New
				</BaseButton>
			</div>
		<div>
			<table class="table">
				<thead>
					<tr>
						<th>Department</th>
						<th>Function</th>
						<th>Key Performance Indicator (KPI)</th>
						<th>Type</th>
						<th>Target</th>
						<th width="100px"></th>
					</tr>
				</thead>
			</table>
		</div>
		<div class="tbl-body">
			<table class="table">
				<tbody>
					<tr v-for="(item, index) in target_list" :key="index">
						<td class="capitalize">
							<span v-if="item.department ">{{getDepartmentName(item.department)}}</span>
							<span v-else-if="item.function ">{{getFunctionByDepartmentName(item.function)}}</span>
							<span v-else>Applicable To All</span>
						</td>
						<td class="capitalize">
							<span v-if="!item.function ">Applicable To All</span>
							<span v-else>{{getFunctionName(item.function)}}</span>
						</td>
						<td>
							<span v-for="(kpi, KpIndex) in kpi_list" :key="KpIndex">
								<span v-if="kpi.value == item.kpi">{{kpi.label}}</span>
							</span>
						</td>
						<td class="capitalize">{{item.type}}</td>
						<td>{{item.target}} {{item.kpi == "labour_cost" ? "%": ""}}</td>
						<td width="100px" >

							<img class="cursor-pointer mr-2" src="../../../../../assets/images/edit.png" width="20" @click="editTarget(item, index)">
							<img class="cursor-pointer" src="../../../../../assets/images/delete-icon.png" width="20" @click="deleteTarget(item.id, index)">
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<!-- <div class="pt-2">
			<el-row class="my-2" :gutter="30">
				<el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="my-4 text-center font-bold">Set Target</p>
				</el-col>
				<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
					<el-select
						v-model="select_target"
						style="width:100%"
						placeholder="Select"
					>
						<el-option
							v-for="item in options"
							:key="item.value"
							:label="item.label"
							:value="item.value"
						>
						</el-option>
					</el-select>
				</el-col>
				<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
					<div v-if="select_target === 'weekly'">
						<el-date-picker
							v-model="startTimeSelect_target"
							placeholder="From"
							style="width:100%"
							type="week"
							:format="startWeekFormat"
							:picker-options="dateRangeOptions"
							@change="startWeek"
						>
						</el-date-picker>
					</div>
					<div v-else>
						<el-date-picker
							v-model="firstdays"
							placeholder="From"
							style="width:100%"
							type="date"
						>
						</el-date-picker>
					</div>
				</el-col>
				<el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
					<div v-if="select_target === 'weekly'">
						<el-date-picker
							v-model="endTimeSelect_target"
							placeholder="To"
							style="width:100%"
							type="week"
							:format="endWeekFormat"
							:picker-options="dateRangeOptions"
							@change="endWeek"
						>
						</el-date-picker>
					</div>
					<div v-else>
						<el-date-picker
							v-model="lastdays"
							placeholder="To"
							style="width:100%"
							type="date"
						>
						</el-date-picker>
					</div>
				</el-col>
			</el-row>
		</div> -->
		<!-- <div class="pt-6">
			<el-row class="my-2" :gutter="30">
				<el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4">
					<p class="my-4 text-center font-bold">IPLH</p>
				</el-col>
				<el-col :xs="6" :sm="6" :md="4" :lg="4" :xl="4">
					<BaseInput
						v-model="weekly_target"
						class="baseInput"
						style="width: 80%;  -webkit-appearance: none; "
						type="text"
						custom-class="p-2 text-sm  text-amp-input-boxes"
					/>
				</el-col>
			</el-row>
		</div> -->

		 <div>
			<el-row class="card text-right my-2 border-top-btn-sec" :gutter="20">
            <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
              <div  style="width: 6rem; float: right">
                <BaseButton buttonclass="btn p-2 text-sm orng-btn" @click="addSaveWeekly">
                  <span v-if="storeId == ''">Save</span>
					<span v-else>Update</span>
                </BaseButton>
              </div>
            </el-col>
          </el-row>
		</div> 

		<!-- <div class="flex justify-end py-4">
			<div style="width: 7rem;">
				<BaseButton buttonclass="btn p-2 text-xs" @click="addSaveWeekly">
					<span v-if="storeId == ''">Save</span>
					<span v-else>Update</span>
				</BaseButton>
			</div>
		</div> -->

		<el-dialog :key="targetPopupKey" title="Set Target" :visible.sync="targetPopup" :before-close="closePopup" width="50%">
			<el-row>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="mt-2 font-bold">Target By <span style="color:red;">*</span></p>
				</el-col>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<el-select v-model="targetBy" v-validate="targetPopup ? 'required' : ''" filterable placeholder="Select" style="width: 100%;" name="Target By" @change="checkDepartment(department)">
						<el-option
						label="Store"
						value="store">
						</el-option>
						<el-option
						label="Department"
						value="department">
						</el-option>
						<!-- <el-option
						label="Functions"
						value="function">
						</el-option> -->
					</el-select>
					<p>
						<span
							:v-show="errors.has('Target By')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("Target By") }}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row v-if="targetBy == 'department'" class="mt-4">
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="mt-2 font-bold">Department <span style="color:red;">*</span></p>
				</el-col>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<el-select v-model="department" v-validate="targetBy == 'department' ? 'required' : ''" filterable placeholder="Select" style="width: 100%;" name="Department" @change="checkDepartment(department)">
						<el-option
						v-for="(dept, deptIndex) in department_list"
						:key="deptIndex"
						:label="dept.department"
						:value="dept.id">
						</el-option>
					</el-select>
					<p>
						<span
							:v-show="errors.has('Department')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("Department") }}
						</span>
					</p>
				</el-col>
			</el-row>
			<el-row v-if="targetBy == 'function'" class="mt-4">
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="mt-2 font-bold">Funtion <span style="color:red;">*</span></p>
				</el-col>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<el-select v-model="functions" multiple
    collapse-tags filterable placeholder="Select" style="width: 100%;" name="Funtion" @change="checkDepartment(department)">
						<el-option
						v-for="(func, funcIndex) in function_list"
						:key="funcIndex"
						:label="func.function"
						:value="func.id">
						</el-option>
					</el-select>
				</el-col>
			</el-row>

			<el-row class="mt-4">
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="mt-2 font-bold">Key Performance Indicator (KPI) <span style="color:red;">*</span></p>
				</el-col>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<el-select v-model="selectKpi" v-validate="targetPopup ? 'required' : ''" filterable placeholder="Select" name="kpi" style="width: 100%;">
						<el-option
						v-for="(kpi, kpiIndex) in kpi_list"
						:key="kpiIndex"
						:disabled="selctedDept.includes(kpi.value)"
						:label="kpi.label"
						:value="kpi.value">
						</el-option>
					</el-select>
					<p>
						<span
							:v-show="errors.has('kpi')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("kpi") }}
						</span>
					</p>
				</el-col>
			</el-row>

			<el-row v-if="selectKpi == 'transactions'" class="mt-4">
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="mt-2 font-bold">Type</p>
				</el-col>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<el-select v-model="type" filterable placeholder="Select" style="width: 100%;">
						<el-option
						v-for="(typ, typeIndex) in options"
						:key="typeIndex"
						:label="typ.label"
						:value="typ.value">
						</el-option>
					</el-select>
				</el-col>
			</el-row>

			<el-row class="mt-4">
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<p class="mt-2 font-bold">Target <span style="color:red;">*</span></p>
				</el-col>
				<el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
					<el-input v-model="target" v-validate="targetPopup ? 'required' : ''"  type="number" style="width: 100%;" name="Target" placeholder="Please input"></el-input>
					<p>
						<span
							:v-show="errors.has('Target')"
							class=" text-red-dark text-xs"
						>
							{{ errors.first("Target") }}
						</span>
					</p>
				</el-col>
			</el-row>

			<span slot="footer" class="dialog-footer">
				<el-button size="mini" class="action-btn" @click="targetPopup = false">Cancel</el-button>
				<el-button v-if="!targetId" size="mini" class="action-btn" @click="saveTarget">Save</el-button>
				<el-button v-if="targetId" size="mini" class="action-btn" @click="updateTarget">Update</el-button>
			</span>
		</el-dialog>
		<!-- <el-dialog title="Please confirm !" :visible.sync="isShowPopUp" width="40%">
			<span>Are you sure you want to continue without saving changes?</span>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowPopUp = false">No</el-button>
				<el-button type="warning" size="mini" @click="changeUrl">Yes</el-button>
			</span>
		</el-dialog> -->
	</div>
</template>
<script>
import { mapState } from "vuex";
import { EventBus } from "../../../../../eventBus";
import LabourPalnningService from "../../../../../services/labourPalnningService";
import moment from "moment";
import _ from "lodash";
export default {
	name: "Target",
	data() {
		return {
			dateRangeOptions: {
				firstDayOfWeek: 1
			},
			kpi_list: [
				{
					label: "Items Per Labour Hour (IPLH)",
					value: "items_per_labour_hour"
				},
				{
					label: "GCPMH / GCPLH / TPLH",
					value: "transactions_per_labour_hour"
				},
				{
					label: "Labour Cost %",
					value: "labour_cost"
				},
				{
					label: "Transactions",
					value: "transactions"
				}
			],
			options: [
				{
					value: "daily",
					label: "Daily"
				},
				{
					value: "weekly",
					label: "Weekly"
				}
			],
			targetBy: "",
			department: "",
			functions: [],
			selectKpi: "",
			type: "",
			target: null,
			target_list: [],
			department_list: [],
			function_list: [],
			endTimeSelect_target: "",
			startTimeSelect_target: "",
			select_target: "",
			changeKeys: false,
			weekly_target: "",
			storeId: "",
			targetId: "",
			firstdays: "",
			lastdays: "",
			startWeekFormat: "",
			targetPopupKey: 0,
			endWeekFormat: "",
			targetPopup: false,
			selctedDept:[]
		};
	},
	computed: {
		...mapState("LabourPlanning", ["storeName"])
	},
	mounted() {
		EventBus.$on("updateStoreData", this.getTarget);
	},
	created() {
		this.getTarget();

	},
	methods: {
		openTargetPopup() {
			this.target = "";
			this.targetId = "",
			this.selectKpi = "";
			this.type = "";
			this.targetPopupKey += 1;
			this.selctedDept = [];
			this.department = "";
			this.targetPopup = true;
		},
		deleteTarget(id, index) {
			LabourPalnningService.deleteTarget(id).then(response => {
				this.target_list.splice(index, 1);
			})
			.catch(err => {
				console.log(err);
			})
		},
		getFunctionName(id) {
			for(let i = 0; i < this.function_list.length; i++) {
				if (this.function_list[i].id == id) {
					return this.function_list[i].function;
				}
			}
		},
		getFunctionByDepartmentName(id) {
			for(let i = 0; i < this.function_list.length; i++) {
				if (this.function_list[i].id == id) {
					return this.getDepartmentName(this.function_list[i].store_department);
				}
			}
		},
		getDepartmentName(id) {
			for(let i = 0; i < this.department_list.length; i++) {
				if (this.department_list[i].id == id) {
					return this.department_list[i].department;
				}
			}
		},
		checkDepartment(dept) {
			this.selctedDept = [];
			if(dept) {
				for(let j in this.target_list) {
					if(dept == this.target_list[j].department) {
						this.selctedDept.push(this.target_list[j].kpi)
					}
					// for(let d in this.target_list[j].departments) {
					// }
				}
			}
		},
		closePopup() {
			this.target = "";
			this.targetId = "",
			this.selectKpi = "";
			this.type = "";
			this.selctedDept = [];
			this.targetPopup = false;
			this.department = "";
			this.targetPopupKey = 0;
		},
		editTarget(item, index) {
			this.target = item.target;
			this.targetId = item.id,
			this.selectKpi = item.kpi;
			// this.type = item.type;
			this.targetBy = item.target_by;
			this.functions = item.function ? [item.function] : [];
			this.department = item.department;
			this.targetPopup = true;
			// if(item.departments.length > 1) {
			// 	this.department = item.departments.map(el => el.id);
			// } else {
			// 	this.department = item.departments[0].id;
			// }
			this.checkDepartment(this.department);
			// console.log(item);
		},
		updateTarget() {
			this.$validator.validateAll().then(result => {
				if (result) {
				let params = {
					outlets: [this.storeName],
					// store_id: this.storeName,
					departments: this.department != "all" ? this.department ? [this.department] : [] : [],
					functions: this.functions ? this.functions : [],
					target: this.target,
					type: "daily",
					target_by: this.targetBy,
					kpi: this.selectKpi
				};
				LabourPalnningService.updateTarget(params,this.targetId)
						.then(response => {
							this.$notify.success({
								title: "Success",
								message: "Target Updated Succesfully"
							});
							this.getTarget();
							this.targetId = "";
							this.targetPopup = false;
							this.department = [];
							this.functions = "";
							this.target = "";
							this.type = "";
							this.targetBy = "";
							this.selectKpi = "";
						})
						.catch(error => {
							console.log("error", error);
						});
				}
			})
		},
		saveTarget() {
			this.$validator.validateAll().then(result => {
				if (result) {
					let params = {
						outlets: [this.storeName],
						// store_id: this.storeName,
						departments: this.department ? [this.department] : [],
						functions: this.functions ? this.functions : [],
						target: this.target,
						type: "daily",
						target_by: this.targetBy,
						kpi: this.selectKpi
					};
					LabourPalnningService.addTarget(params)
							.then(response => {
								this.$notify.success({
									title: "Success",
									message: "Target Saved Succesfully"
								});
								this.getTarget();
								this.targetPopup = false;
								this.department = [];
								this.functions = "";
								this.target = "";
								this.type = "";
								this.targetBy = "";
								this.selectKpi = "";
							})
							.catch(error => {
								console.log("error", error);
							});
				}
			})
		},
		startWeek() {
			let date = this.startTimeSelect_target;
			var dt = new Date(date); // current date of week
			var currentWeekDay = dt.getDay();
			var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
			var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
			var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
			this.firstdays = moment(wkStart).format("YYYY-MM-DD");
			let lastdays = moment(wkEnd).format("YYYY-MM-DD");

			this.startWeekFormat = `${this.firstdays} To ${lastdays}`;
		},
		endWeek() {
			let date = this.endTimeSelect_target;
			var dt = new Date(date); // current date of week
			var currentWeekDay = dt.getDay();
			var lessDays = currentWeekDay == 0 ? 6 : currentWeekDay - 1;
			var wkStart = new Date(new Date(dt).setDate(dt.getDate() - lessDays));
			var wkEnd = new Date(new Date(wkStart).setDate(wkStart.getDate() + 6));
			let firstdays = moment(wkStart).format("YYYY-MM-DD");
			this.lastdays = moment(wkEnd).format("YYYY-MM-DD");

			this.endWeekFormat = `${firstdays} To ${this.lastdays}`;
		},
		addSaveWeekly() {
			this.$notify.success({
				title: "Success",
				message: "Target Updated Succesfully"
			});
			// if (this.storeId) {
			// 	var params = {
			// 		store: this.storeName,
			// 		value: this.weekly_target,
			// 		type: this.select_target,
			// 		from_date: `${moment(this.firstdays).format("YYYY-MM-DD")}`,
			// 		to_date: `${moment(this.lastdays).format("YYYY-MM-DD")}`
			// 	};
			// 	LabourPalnningService.updateIplhs(this.storeId, params)
			// 		.then(response => {
			// 			this.$notify.success({
			// 				title: "Success",
			// 				message: "Iplh Update Succesfully"
			// 			});
			// 		})
			// 		.catch(error => {
			// 			console.log("error", error);
			// 		});
			// } else {
			// 	var params = {
			// 		store: this.storeName,
			// 		value: this.weekly_target,
			// 		// type: this.select_target,
			// 		from_date: `${moment(this.firstdays).format("YYYY-MM-DD")}`,
			// 		to_date: `${moment(this.lastdays).format("YYYY-MM-DD")}`
			// 	};
			// 	LabourPalnningService.addIplh(params)
			// 		.then(response => {
			// 			// console.log(response);
			// 			this.$notify.success({
			// 				title: "Success",
			// 				message: "Iplh Create Succesfully"
			// 			});
			// 		})
			// 		.catch(error => {
			// 			console.log("error", error);
			// 		});
			// }
		},
		getDepartment() {
			if(this.storeName){
				let params = {
					outlet_id: this.storeName
				};
				LabourPalnningService.getStoreDepartments(params)
				.then(response => {
					if(response.status == 200){
						let res = JSON.parse(response.data);


						if(res.length){
							this.department_list = res;
						}else{
							this.department_list = [];
						}
					}else{
						this.department_list = [];
					}
				})
				.catch(err => {
					console.log(err);
				});
				LabourPalnningService.getWorkArea(params)
					.then(response => {
						this.function_list = JSON.parse(response.data);
						var commonDepartMents = _.uniqBy(this.function_list, "store_department");
						let department = [];
						for(let i in commonDepartMents) {
							for(let j in res) {
								if(res[j].id == commonDepartMents[i].store_department) {
									department_list.push(this.res[j])
								}
							}

						}
						this.departmentList = department;
					})
					.catch(err => {
						console.log(err);
					});
			}
		},
		getTarget() {
			this.getDepartment();
			LabourPalnningService.getTargetList(this.storeName)
					.then(response => {
						this.target_list = JSON.parse(response.data).results;
					})
					.catch(err => {

					})
		},
		getIplhDetail() {
			if (this.storeName) {
				var params = {
					outlet_id: this.storeName
				};
				LabourPalnningService.getIplhDetails(params)
					.then(response => {
						if (response.data != "") {
							var targetData = JSON.parse(response.data)[0];
							// if (targetData.type === "weekly") {
							// 	this.endTimeSelect_target = targetData.to_date;
							// 	this.startTimeSelect_target = targetData.from_date;
							// 	this.startWeek();   ***
							// 	this.endWeek();
							// } else {
							// 	this.firstdays = targetData.from_date;
							// 	this.lastdays = targetData.to_date;
							// }
							// this.select_target = targetData.type;
							// this.weekly_target = targetData.value;
							// this.storeId = targetData.id;
						} else {
							this.endTimeSelect_target = "";
							this.startTimeSelect_target = "";
							this.select_target = "";
							this.weekly_target = "";
							this.storeId = "";
						}
					})
					.catch(error => {
						// console.log("Store Details response", error);
						// this.$notify.error({
						// 	title: "Warning",
						// 	message: "Store Details not found"
						// });
					});
			}
		}
	}
};
</script>
<style lang="scss">
@import "./Target.scss";
.border-top-btn-sec{ 
  padding-top: 15px;
  border-top: 1px solid #dae1e7;
}
</style>
